<template>
    <el-popover
        ref="task-edit"
        placement="top"
        title=""
        width="870"
        trigger="manual"
        v-model="showExpenseEdit"
        :visible-arrow="false"
        popper-class="expense-regular-edit"
        v-on-clickaway="hideForm"
    >
        <el-row class="mb10">
            <el-col :span="24" class="label" v-if="issetCurrentExpenseId">
                <expense-regular-edit
                    :id="currentExpenseId"
                    @closePopUp="closePopUp"
                    @getDataFromServer="getDataFromServer"
                />
            </el-col>
        </el-row>
    </el-popover>
</template>

<script>
import '@/assets/styles/expenses-deals.scss';
import { mixin as clickaway } from 'vue-clickaway';
import ExpenseRegularEdit from '@/components/expenses/ExpenseRegularEdit.vue';

export default {
    name: 'ExpenseRegularEditPopup',
    mixins: [
        clickaway
    ],
    data() {
        return {
            showExpenseEdit: false,
            currentExpenseId: null
        };
    },
    props: {
        expenseId: {
            type: Number,
            default: 0
        },
        isVisible: {
            type: Boolean,
            default: false
        }
    },
    components: {
        ExpenseRegularEdit
    },
    computed: {
        issetCurrentExpenseId() {
            return +this.currentExpenseId > 0 || this.currentExpenseId === -1;
        }
    },
    methods: {
        closePopUp(value) {
            this.showExpenseEdit = value;
            this.currentExpenseId = null;
            this.$emit('changeVisibility', value);
        },
        hideForm(event) {
            if (this.showExpenseEdit && !(event.target.id === ('create-expense-regular')) && !event.target.classList.contains('create-expense-regular-title')) {
                this.showExpenseEdit = false;
                this.currentExpenseId = null;
                this.$emit('changeVisibility', false);
            }
        },
        getDataFromServer() {
            this.$emit('getDataFromServer');
        }
    },
    watch: {
        isVisible(value) {
            this.showExpenseEdit = value;
        },
        expenseId(value) {
            this.currentExpenseId = value;
        }
    }
};
</script>
